import React, { Component } from 'react';
import store from "store/store";
import Joi from "joi-browser";
import { connect } from "react-redux";
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import { BackButtonPage } from "components/__new/common/BackButton";
import * as admin from "store/entities/settingsAdmin/action";


class AdminEdit extends Component {

    state = {
        _id: "",
        adminForm: {
            firstName: "",
            lastName: "",
            email: "",
            phoneNumber: "",
            jobTitle: "",
            isActive: "",
        },
        errors: {},
        storeUnsubscribe1: "",
        storeUnsubscribe2: "",
    }


    goBack = () => {
        this.props.history.goBack();
    }
    

    formChange = (e) => {
        const formValue = {...this.state.adminForm};
        formValue[e.currentTarget.name] = e.currentTarget.value;
        this.setState({adminForm: formValue});
    }

    
    schema = {
        firstName: Joi.string().required().label("First Name").error(errors => {
            errors.forEach(err => {
                switch (err.type) {
                    case "any.empty":
                        err.message = "Please enter the admin's first name";
                        break;
                    default:
                        break;
                }
            });
            return errors;
        }),
        lastName: Joi.string().required().label("Last Name").error(errors => {
            errors.forEach(err => {
                switch (err.type) {
                    case "any.empty":
                        err.message = "Please enter the admin's last name";
                        break;
                    default:
                        break;
                }
            });
            return errors;
        }),
        email: Joi.string().email().required().label("Email Address").error(errors => {
            errors.forEach(err => {
                switch (err.type) {
                    case "any.empty":
                        err.message = "Please enter the admin's email address";
                        break;
                    case "string.email":
                        err.message = "Please enter the admin's email address";
                        break;
                    default:
                        break;
                }
            });
            return errors;
        }),
        phoneNumber: Joi.string().min(11).max(11).required().label("Phone Number").error(errors => {
            errors.forEach(err => {
                switch (err.type) {
                    case "any.empty":
                        err.message = "Please enter admin's phone number";
                        break;
                    case "string.min":
                        err.message = `Please enter 11 digits for admin's phone number`;
                        break;
                    case "string.max":
                        err.message = `Please enter 11 digits for admin's phone number`;
                        break;
                    default:
                        break;
                }
            });
            return errors;
        }),
        jobTitle: Joi.string().required().label("Job Title").error(errors => {
            errors.forEach(err => {
                switch (err.type) {
                    case "any.empty":
                        err.message = "Please enter the admin's job title";
                        break;
                    default:
                        break;
                }
            });
            return errors;
        }),
    }


    validate = () => {
        const options = { abortEarly: false, allowUnknown: true };
        const result = Joi.validate(this.state.adminForm, this.schema, options);
        // console.log(result);
        const error = result.error;
        if (!error) return null;
    
        const errors = {};
        for (let item of result.error.details){
            errors[item.path[0]] = item.message;
        }
        return errors;
    };


    submitForm = async e => {
        e.preventDefault();
        const errors = this.validate();
        this.setState({errors: errors || {}});
        if (errors){
            // console.log(errors);
            for (var x in errors) {
                toast.error(errors[x]);
            };
            return;
        }
        else{
            // console.log("this.state.adminForm",this.state.adminForm);
            this.props.editAdmin(this.state._id, this.state.adminForm);
        }
    }
    

    componentDidMount() {
        if ("id" in this.props.match.params){
            const {id} = this.props.match.params;
            this.props.getAdmin(id);

            this.unsubscribe1 = store.subscribe(() => {
                if ((this.props.getLoading === false) && (Object.keys(this.props.admin).length > 0)){
                    this.unsubscribe1();
                    const adminForm = this.props.admin;
                    // console.log(adminForm);
                    this.setState({_id: adminForm._id, adminForm});
                }
            });
            this.setState({storeUnsubscribe1: this.unsubscribe1});

            this.unsubscribe2 = store.subscribe(() => {
                if (this.props.editSuccess === true){
                    this.unsubscribe2();
                    this.props.resetAdminEditSuccess();
                    // this.props.history.push("/settings/administrators");
                    this.goBack();
                }
            });
            this.setState({storeUnsubscribe2: this.unsubscribe2});
        }
    }


    componentWillUnmount(){
        const { storeUnsubscribe1, storeUnsubscribe2 } = this.state;
        // console.log("storeUnsubscribe1", storeUnsubscribe1);
        if ((storeUnsubscribe1 !== "") && (storeUnsubscribe1 !== undefined) && (storeUnsubscribe1 !== null)){
            storeUnsubscribe1();
        }
        if ((storeUnsubscribe2 !== "") && (storeUnsubscribe2 !== undefined) && (storeUnsubscribe2 !== null)){
            storeUnsubscribe2();
        }
    }

    
    componentDidUpdate(prevProps, prevState) {
        if (this.state !== prevState){
                
            if (this.props.editSuccess === true){
                this.props.resetAdminEditSuccess();
                this.goBack();
            }

        }
    }


    render() { 
        const {adminForm} = this.state;

        return ( 
            <div>
                
                <DynamicHeadTag
                    headerText="Settings"
                    headerDescription="Customize your account preferences, including account information, security and privacy settings, notifications, and other account-related options."
                />


                <div className="lg:flex">
                    <div className="w-full lg:w-1/2">
                        <div className="page-title flex">
                            <BackButtonPage />
                            Edit
                        </div>
                    </div>
                    <div className="w-full lg:w-1/2 flex mt-4 lg:mt-0 lg:justify-end space-x-3"></div>
                </div>


                {(this.props.getLoading === true) && 
                    <div className="table-info-full-page">
                        <div className="table-info">
                            <FontAwesomeIcon icon="circle-notch" spin />
                            <div className="font-bold uppercase">
                                Loading
                            </div>
                        </div>
                    </div>
                }

                {(this.props.getLoading === false) && (Object.keys(this.props.admin).length === 0) && 
                    <div className="table-info-full-page">
                        <div className="table-info">
                            <FontAwesomeIcon icon="clipboard" />
                            <div className="font-bold uppercase">
                                Admininistrator not found
                            </div>
                        </div>
                    </div>
                }

                {(this.props.getLoading === false) && (Object.keys(this.props.admin).length > 0) && 

                    <div className="mt-8 space-y-6 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-x-6">

                        <form className="box col-span-2" onSubmit={this.submitForm}>

                            <div className="font-medium text-gray-600">
                                Edit Administrator Details
                            </div>

                            <div className="mt-6 sm:grid sm:grid-cols-2 sm:gap-x-6">
                                
                                <div className="form-group">
                                    <label>
                                        First name
                                        <span className="form-input-required">*</span>
                                    </label>
                                    <input type="text" name="firstName" placeholder="Enter First Name" className="form-input" value={adminForm.firstName} onChange={this.formChange} />
                                </div>

                                <div className="form-group">
                                    <label>
                                        Last name
                                        <span className="form-input-required">*</span>
                                    </label>
                                    <input type="text" name="lastName" placeholder="Enter Last Name" className="form-input" value={adminForm.lastName} onChange={this.formChange} />
                                </div>
                                
                                <div className="form-group">
                                    <label>
                                        Email Address
                                        <span className="form-input-required">*</span>
                                    </label>
                                    <input type="email" name="email" placeholder="Enter Employee Email Address" className="form-input" value={adminForm.email} onChange={this.formChange} disabled />
                                </div>

                                <div className="form-group">
                                    <label>
                                        Phone Number
                                        <span className="form-input-required">*</span>
                                    </label>
                                    <input type="tel" name="phoneNumber" placeholder="Enter Admin Phone Number" className="form-input" value={adminForm.phoneNumber} onChange={this.formChange} />
                                </div>

                                <div className="form-group">
                                    <label>
                                        Job Title
                                        <span className="form-input-required">*</span>
                                    </label>
                                    <input type="text" name="jobTitle" placeholder="Enter Job Title" className="form-input" value={adminForm.jobTitle} onChange={this.formChange} />
                                </div>

                                <div className="form-group">
                                    <label>
                                        Set Status
                                        <span className="form-input-required">*</span>
                                    </label>
                                    <select name="isActive" className="form-input" value={adminForm.isActive} onChange={this.formChange} >
                                        <option value="" disabled>Select Status</option>
                                        <option value="true">Active</option>
                                        <option value="false">Inactive</option>
                                    </select>
                                </div>

                            </div>

                            <button type="submit" className="btn btn-lg btn-ep-primary mt-2" disabled={this.props.editLoading}>
                                <FontAwesomeIcon icon="circle-notch" spin className={"text-xl mr-2 " + (this.props.editLoading?"inline":"hidden")} />
                                Save Changes
                            </button>

                        </form>
                        
                    </div>
                    
                }

            </div>
        );
    }
}


const mapStateToProps = (state) => ({
    getLoading: state.entities.settingsAdmin.getAdminLoading,
    admin: state.entities.settingsAdmin.getAdmin,
    editLoading: state.entities.settingsAdmin.adminUpdateLoading,
    editSuccess: state.entities.settingsAdmin.adminUpdateSuccess
});

const mapDispatchToProps = (dispatch) => ({
    getAdmin: (id) => dispatch(admin.getAdmin(id)),
    editAdmin: (id, params) => dispatch(admin.editAdmin(id, params)),
    resetAdminEditSuccess: () => dispatch(admin.resetAdminEditSuccess())
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminEdit);